export default __webpack_public_path__ + "static/media/process_Support.3802fc55.png";